import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import LayoutDashboard from "../layout/layout";
import Login from "../pages/Auth/login/login";
import PrivateRoute from "./private-route";
import { ConfigProvider } from "antd";

const customTheme = {
  token: {
    // 1. Apply the Primary Color
    colorPrimary: "#E73334",
    // 2. Apply the Font Family
    fontFamily: "Roboto, sans-serif",
    // You can add more tokens here like borderRadius: 4, etc.
  },
};
const Navigation = () => {
  return (
    <ConfigProvider theme={customTheme}>
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <LayoutDashboard />
            </PrivateRoute>
          }
        >
          {/* <Route path="/dashboard" element={<Pages.Dashboard />} /> */}
        </Route>
      </Routes>
    </ConfigProvider>
  );
};

export default Navigation;
